module.exports = __webpack_public_path__ + "img/aqmola3.f53db671.jpg";